import React, { useEffect, useState } from "react";
import * as Styled from "./styles";
import { Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { ScheduledOrderCard } from "./components/ScheduledOrderCard";
import { handleGetScheduledCheckoutItemsRequest } from "store/modules/Checkout/thunk.store";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { RootState } from "store/index";
import { useAuth } from "context/AuthContext";
import { CheckoutItemProps } from "store/modules/Checkout/types.store";

const ScheduleOrders = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [offset, setOffset] = useState(0);
  const LIMIT = 10;

  const dispatch = useAppDispatch();
  const { dealerId } = useAuth();
  const { checkoutItems } = useAppSelector(
    (state: RootState) => state.checkout,
  );

  useEffect(() => {
    setOffset(0);
    dispatch(
      handleGetScheduledCheckoutItemsRequest({
        dealerId: dealerId || "",
        limit: LIMIT,
        offset: 0,
      }),
    );
  }, [dispatch, dealerId]);

  const handleLoadMore = () => {
    const newOffset = offset + LIMIT;
    setOffset(newOffset);

    dispatch(
      handleGetScheduledCheckoutItemsRequest({
        dealerId: dealerId || "",
        limit: LIMIT,
        offset: newOffset,
      }),
    );
  };

  return (
    <Styled.Container>
      <Styled.ContainerButton>
        <Button
          onClick={() => navigate("/orders/manage")}
          color="inherit"
          variant="text"
        >
          <ArrowBackIcon />
          {t("back")}
        </Button>
      </Styled.ContainerButton>
      <Typography variant="body1">{t("scheduledOrdersDescription")}</Typography>
      <Styled.CardContainer>
        <Typography variant="h6">{t("scheduledOrdersTitle")}</Typography>
      </Styled.CardContainer>
      {checkoutItems &&
        checkoutItems.length > 0 &&
        checkoutItems.map((item: CheckoutItemProps) => (
          <ScheduledOrderCard key={item.id} data={item} />
        ))}
      {checkoutItems && checkoutItems.length > 0 && (
        <Styled.LoadMoreContainer>
          <Button
            onClick={handleLoadMore}
            variant="text"
            color="primary"
            fullWidth
          >
            Carregar mais
          </Button>
        </Styled.LoadMoreContainer>
      )}
    </Styled.Container>
  );
};

export default ScheduleOrders;
